<app-page-panel class="flex-fit"
    [showBackButton]="false"
    iconNameFontAwesome="payments"
    pageTitle="Baunebenkosten"    
    [showBackColor]="true"
    [showDetailsButton]="false"
    [showSidepanelButton]="false"
    [showCloseButton]="true"
    [showContent]="false"
    (closeButtonClicked)="onCloseClick()">
</app-page-panel>
<form [formGroup]="baunebenkostenForm" (ngSubmit)="onFormSubmit()">
    <mat-dialog-content>
        <div class="form-group flex flex-col flex-fill flex-stretch-self flex-justify">
            <div class="flex flex-row flex-fill flex-gap-12 flex-justify">
                <mat-form-field class="flex-fill">
                    <mat-label>Berechnung</mat-label>
                    <mat-select formControlName="bnkBerechnung" name="controlling" required>
                        @for (item of dataBerechnungen(); track item) {
                            <mat-option [value]="item">{{item.berechnung}}</mat-option>
                        }                            
                    </mat-select>                        
                </mat-form-field>      
            </div>
            <div class="flex flex-row flex-fill flex-gap-12 flex-justify">
                <mat-form-field class="flex-fill">
                    <mat-label>Baunebenkosten</mat-label>
                    <input matInput 
                        formControlName="bnkProzent" 
                        type="number" 
                        min="0" 
                        max="100" 
                        placeholder="">
                    <span matTextSuffix>%&nbsp;</span>
                    @if (ctlBnkProzent.invalid) {
                        <mat-error>Geben Sie einen Wert an</mat-error>
                    }                
                </mat-form-field>
                <mat-form-field class="flex-fill">
                    <mat-label>Baunebenkosten 1-4</mat-label>
                    <input matInput 
                        formControlName="bnk1bis4Prozent"
                        type="number" 
                        min="0" 
                        max="100" 
                        placeholder="" >
                    <span matTextSuffix>%&nbsp;</span>
                    @if (ctlBnk1bis4Prozent.invalid) {
                        <mat-error>BNK 1-4 und 5-9 müssen 100% ergeben</mat-error>
                    }                
                </mat-form-field>  
                <mat-form-field class="flex-fill">
                    <mat-label>Baunebenkosten 5-9</mat-label>
                    <input matInput 
                        formControlName="bnk5bis9Prozent" 
                        type="number" 
                        min="0" 
                        max="100" 
                        placeholder="">
                    <span matTextSuffix>%&nbsp;</span>
                    @if (ctlBnk5bis9Prozent.invalid) {
                        <mat-error>BNK 1-4 und 5-9 müssen 100% ergeben</mat-error>
                    }                
                </mat-form-field>
            </div>
            <mat-form-field class="flex-fill form-field-remove-hint">
                <mat-label>Begründung bei Veränderung</mat-label>
                <textarea matInput rows="6" placeholder="Begründung" formControlName="bnkVeraenderung" maxlength="500"></textarea>
                @if (ctlBnkVeraenderung.invalid) {
                    <mat-error>Geben Sie ein Begründung für die veränderten Baunebenkosten an</mat-error>
                }                
            </mat-form-field>
        </div>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
        <button mat-button type="submit" [disabled]="!isFormEditStateValid()" cdkFocusInitial>Speichern</button>
        <button mat-button mat-dialog-close>Abbrechen</button>
    </mat-dialog-actions>
</form>
